/**
 * Bella cart write shield — must load BEFORE Shopify app scripts (content_for_header).
 * Blocks Product Addons (addons.js) cart mutations while drawer upsell ATC is active,
 * so preorder/addon lines are not wiped after a quiet upsell add.
 */
(function (w) {
  if (w.__bellaCartWriteShield) return;
  w.__bellaCartWriteShield = true;

  var state = {
    blockUntil: 0,
    ownDepth: 0,
    atcActive: false,
  };

  /**
   * Only block destructive cart mutations from Product Addons (change/update/clear).
   * Never block /cart/add — PDP / sticky ATC must always reach Shopify or the first
   * click only opens the drawer with a fake "success" and the item never lands.
   */
  function isCartMutateUrl(url) {
    return /\/cart\/(change|clear|update)(\.js)?(\?|$)/i.test(String(url || ''));
  }

  function shouldBlockForeign() {
    return state.ownDepth < 1 && (state.atcActive || Date.now() < state.blockUntil);
  }

  function blockedFetchResponse() {
    return new Response(JSON.stringify({ ok: true, bella_blocked: true }), {
      status: 200,
      headers: { 'Content-Type': 'application/json' },
    });
  }

  var rawFetch = typeof w.fetch === 'function' ? w.fetch.bind(w) : null;
  w.__bellaRawFetch = rawFetch;

  w.BellaCartWriteShield = {
    block: function (ms) {
      var until = Date.now() + (ms || 12000);
      if (until > state.blockUntil) state.blockUntil = until;
    },
    setAtcActive: function (v) {
      state.atcActive = !!v;
    },
    isAtcActive: function () {
      return !!state.atcActive;
    },
    clear: function () {
      state.blockUntil = 0;
      state.atcActive = false;
    },
    allowOwn: function (promiseFactory) {
      state.ownDepth += 1;
      return Promise.resolve()
        .then(function () {
          return promiseFactory();
        })
        .finally(function () {
          state.ownDepth = Math.max(0, state.ownDepth - 1);
        });
    },
    ownFetch: function (input, init) {
      var self = this;
      return self.allowOwn(function () {
        if (!rawFetch) return Promise.reject(new Error('fetch unavailable'));
        return rawFetch(input, init);
      });
    },
  };

  if (rawFetch) {
    w.fetch = function (input, init) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (err) {
        url = '';
      }
      if (shouldBlockForeign() && isCartMutateUrl(url)) {
        return Promise.resolve(blockedFetchResponse());
      }
      return rawFetch.apply(w, arguments);
    };
  }

  if (typeof XMLHttpRequest !== 'undefined') {
    var rawOpen = XMLHttpRequest.prototype.open;
    var rawSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__bellaCartUrl = url;
      return rawOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var self = this;
      if (shouldBlockForeign() && isCartMutateUrl(self.__bellaCartUrl)) {
        setTimeout(function () {
          try {
            Object.defineProperty(self, 'status', { configurable: true, get: function () { return 200; } });
            Object.defineProperty(self, 'readyState', { configurable: true, get: function () { return 4; } });
            Object.defineProperty(self, 'responseText', {
              configurable: true,
              get: function () {
                return '{"ok":true,"bella_blocked":true}';
              },
            });
            Object.defineProperty(self, 'response', {
              configurable: true,
              get: function () {
                return self.responseText;
              },
            });
          } catch (err) {
            /* ignore */
          }
          try {
            if (typeof self.onreadystatechange === 'function') self.onreadystatechange();
          } catch (err2) {
            /* ignore */
          }
          try {
            self.dispatchEvent(new Event('readystatechange'));
            self.dispatchEvent(new Event('load'));
          } catch (err3) {
            /* ignore */
          }
        }, 0);
        return;
      }
      return rawSend.apply(this, arguments);
    };
  }
})(window);
